import React from "react";

/**
 * FormField — label + input/textarea ที่ใช้ซ้ำทั่วทุกหน้า AddBuilding
 *
 * Props:
 *  - label      : string   — ข้อความ label
 *  - required   : bool     — ถ้า true จะแสดง * สีแดง (default false)
 *  - multiline  : bool     — ถ้า true จะเป็น <textarea> (default false)
 *  - className  : string   — class เพิ่มเติมสำหรับ wrapper (optional)
 *  - ...rest               — props อื่นๆ ส่งต่อไปยัง input/textarea โดยตรง
 *                            เช่น placeholder, value, onChange, disabled
 */
export default function FormField({
  label,
  required = false,
  multiline = false,
  className = "",
  ...rest
}) {

  
  /** class ร่วมสำหรับ input/textarea */
  const inputClass =
    "w-full border border-slate-300 rounded-md p-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition";

  return (
    <div className={`px-2 py-2 ${className}`}>
      {/* Label */}
      <label className="text-sm block m-1 font-bold text-slate-800">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      {/* Input หรือ Textarea */}
      {multiline ? (
        <textarea className={`${inputClass} h-28`} {...rest} />
      ) : (
        <input type="text" className={`${inputClass} h-10`} {...rest} />
      )}
    </div>
  );
}
